import worker from '@/urls/worker'
import accounts from "@/urls/accounts"
import {
  sendGetRequest, sendPatchRequest,
} from '@/helper/requests'
import { executeRequest } from '@/store/utils'
import organization from '@/store/modules/worker/organization'

const state = {
  worker: {
    workerDetail: null,
    positionHeld: null,
    loadingWorkerDetail: false,
    loadingPositionHeld: false,
    error: null
  },
}

const getters = {
  getWorkerDetail: state => state.worker.workerDetail,
  isLoadingWorkerDetail: state => state.worker.loadingWorkerDetail,
  getPositionHeld: state => state.worker.positionHeld,
  isLoadingPositionHeld: state => state.worker.loadingPositionHeld
}

const actions = {
  loadWorkerDetail: ({ commit }, { url, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает детальную информацию о сотруднике
     * @param {Object} commit - контекст Vuex
     * @param {string} url - URL для загрузки (опционально)
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    commit('SET_WORKERDETAIL_LOADING')
    if (!url) url = accounts.PROFILE.WORKER()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_WORKERDETAIL', data)
        commit('SET_WORKERDETAIL_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_WORKERDETAIL_ERROR', data)
        commit('SET_WORKERDETAIL_LOADING_END')
        catcher(data, url)
      }
    )
  },
  changeWorkerDetail: ({ dispatch, commit, getters }, { data, finalizer, catcher }) => {
    /**
     * Обновляет детальную информацию о сотруднике
     * @param {Object} context - контекст Vuex
     * @param {Object} data - данные для обновления
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = worker.WORKER.UPDATE(data.id)
    executeRequest('WorkerDetail', sendPatchRequest, { url, data, finalizer, catcher }, { dispatch, commit, getters })
  },
  loadPositionHeldDetail: ({ commit }, { url, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает рабочие позиции сотрудника
     * @param {Object} context - контекст Vuex
     * @param {string} url - URL для загрузки (опционально)
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    commit('SET_POSITIONHELD_LOADING')
    if (!url) url = worker.WORKER.POSITION_HELD_DETAIL()
    sendGetRequest(
      url, (data, url) => {
        data = data.sort(function (a, b) {
          if (a.is_fired > b.is_fired) {
            return 1
          }
          if (a.is_fired < b.is_fired) {
            return -1
          }
          return 0
        })
        commit('SET_POSITIONHELD', data)
        commit('SET_POSITIONHELD_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_WORKERDETAIL_ERROR', data)
        commit('SET_POSITIONHELD_LOADING_END')
        catcher(data, url)
      }
    )
  }

}

const mutations = {
  SET_WORKERDETAIL: (state, value) => {
    /**
     * Устанавливает детальную информацию о сотруднике
     * @param {Object} state - состояние хранилища
     * @param {Object} value - данные сотрудника
     */
    state.worker.workerDetail = value
  },
  SET_WORKERDETAIL_LOADING: (state) => {
    /**
     * Включает состояние загрузки детальной информации
     * @param {Object} state - состояние хранилища
     */
    state.worker.loadingWorkerDetail = true
  },
  SET_WORKERDETAIL_LOADING_END: (state) => {
    /**
     * Выключает состояние загрузки детальной информации
     * @param {Object} state - состояние хранилища
     */
    state.worker.loadingWorkerDetail = false
  },
  SAVE_WORKERDETAIL_ERROR: (state, error) => {
    /**
     * Сохраняет ошибки при работе с данными сотрудника
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.worker.error = error
  },
  SET_POSITIONHELD: (state, value) => {
    /**
     * Устанавливает рабочие позиции сотрудника
     * @param {Object} state - состояние хранилища
     * @param {Array} value - список рабочих позиций
     */
    state.worker.positionHeld = value
  },
  SET_POSITIONHELD_LOADING: (state) => {
    /**
     * Включает состояние загрузки рабочих позиций
     * @param {Object} state - состояние хранилища
     */
    state.worker.loadingPositionHeld = true
  },
  SET_POSITIONHELD_LOADING_END: (state) => {
    /**
     * Выключает состояние загрузки рабочих позиций
     * @param {Object} state - состояние хранилища
     */
    state.worker.loadingPositionHeld = false
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules: {
    organization,
  }
}
